import { defineComponent } from 'vue';
export default defineComponent({
    name: 'Modal',
    props: {
        open: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['outer-click'],
});
